let _purify = null;

export default {
  methods: {
    setAlignment(alignment) {
      this.textAlignment = alignment;
      this.updateDescriptionStyle();
    },

    toggleFormat(format) {
      const index = this.textFormats.indexOf(format);
      if (index > -1) {
        this.textFormats.splice(index, 1);
      } else {
        this.textFormats.push(format);
      }
      this.updateDescriptionStyle();
    },

    updateDescriptionStyle() {
      if (!this.site_setting.profile.description_style) {
        this.$set(this.site_setting.profile, 'description_style', {});
      }

      this.site_setting.profile.description_style = {
        formats: [...this.textFormats],
        alignment: this.textAlignment
      };
    },

    getDescriptionStyle() {
      const style = this.site_setting.profile.description_style || {};
      const formats = style.formats || [];
      const alignment = style.alignment || 'left';

      return {
        fontWeight: formats.includes('bold') ? 'bold' : 'normal',
        fontStyle: formats.includes('italic') ? 'italic' : 'normal',
        textDecoration: formats.includes('underline') ? 'underline' : 'none',
        textAlign: alignment,
        color: this.site_setting.profile.desc_color
      };
    },

    addLineBreaks(text) {
      if (!text) return '';
      const htmlWithBreaks = text.replace(/\n/g, '<br>');

      if (!_purify) {
        import('dompurify').then(mod => {
          _purify = mod.default;
        });
        return htmlWithBreaks;
      }

      return _purify.sanitize(htmlWithBreaks, {
        ALLOWED_TAGS: ['br', 'p', 'b', 'strong', 'i', 'em', 'u', 'span'],
        ALLOWED_ATTR: ['style', 'class']
      });
    },

    append(emoji) {
      this.site_setting.profile.description += emoji.native;
    },

    handleDescriptionInput() {
      this.formattedDescription = this.addLineBreaks(this.site_setting.profile.description);
    }
  }
}
